export default "__VITE_ASSET__DgSjwS38__"